export class Homebanner {
  constructor(type, image, url,notice) {
    this.type = type
    this.image = image
    this.url = url
    this.notice = notice

  }

}